var e = {} || e;
( function () {
    'use strict';
    // Define shared variables and settings across application
    e.constant = {
        jWindow: jQuery( window ),
        jHtml: jQuery( 'html' )
    };
    e.config = {
        pageLanguage: e.constant.jHtml.attr( 'lang' ),
        IntergerSeparator: e.constant.jHtml.data( 'integer-separator' ),
        DecimalSeparator: e.constant.jHtml.data( 'decimal-separator' )
    };
    if ( e.config.IntergerSeparator === ' ' ) {
        e.config.regExpIntergerSeparator = new RegExp( '(\\s|&nbsp;)', 'g' );
    }
    else {
        e.config.regExpIntergerSeparator = new RegExp( '\\' + e.config.IntergerSeparator, 'g' );
    }
    if ( e.config.DecimalSeparator === ' ' ) {
        e.config.regExpDecimalSeparator = new RegExp( '(\\s|&nbsp;)', 'g' );
    }
    else {
        e.config.regExpDecimalSeparator = new RegExp( '\\' + e.config.DecimalSeparator, 'g' );
    }
    e.settings = {
        scrollAnimationSpeed: 1800
    };


    jQuery( function () {
        e.util.animateParagraphEntry();
        e.util.galleries.fullscreen.init();
        e.bootstrap.init();
        e.searching.init();
        e.maps.init();
        e.news.init();
        e.dw.extranet.init();
        e.util.scroll.init();
    } );
    jQuery( window ).on( 'load', function () {
        e.util.galleries.init();
        e.util.addthis.init();
        e.util.cookie.message();
        e.newsletterpopup.init();
        e.dw.fixPhoneLinks();
        e.util.toggleGridOverlay();
    } );
}() );
